import { format } from "date-fns";

export const formatTimeHorizonForDisplay = (
  fromTime: Date,
  toTime: Date,
): string => `${format(fromTime, "HH:mm")}–${format(toTime, "HH:mm")}`;
